/** Nombre clicable → ficha cliente o contacto. */
export default function CitaLinkPersona({ nombre, onAbrir, color, style = {} }) {
  const n = nombre != null ? String(nombre).trim() : "";
  if (!n) return <span style={style}>Sin nombre</span>;
  const puede = typeof onAbrir === "function";
  if (!puede) {
    return (
      <span style={{ fontWeight: 600, color: color || "inherit", ...style }}>
        {n}
      </span>
    );
  }
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onAbrir();
      }}
      title="Abrir ficha"
      style={{
        fontSize: "inherit",
        fontWeight: 600,
        color: color || "inherit",
        background: "none",
        border: "none",
        padding: 0,
        cursor: "pointer",
        textDecoration: "underline",
        fontFamily: "inherit",
        textAlign: "left",
        ...style,
      }}
    >
      {n}
    </button>
  );
}
